module.exports = __webpack_public_path__ + "static/img/166_TO8_1907.a06fe09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/166_TO8_1907.jpg
// module id = d6Bf
// module chunks = 0